import { Order } from '@/types'
import { router } from '@inertiajs/react'
import { ActionIcon, Group, Menu, Text, Title } from '@mantine/core'
import { IconDotsVertical, IconEdit, IconHistory, IconPrinter, IconTrash } from '@tabler/icons-react'
import dayjs from 'dayjs'

export function OrderHeader({
  order,
  organizationSlug,
  canEdit,
  canDelete,
  onDelete,
}: {
  order: Order
  organizationSlug: string
  canEdit?: boolean
  canDelete?: boolean
  onDelete?: () => void
}) {
  const goToEdit = () => router.visit(`/organizations/${organizationSlug}/orders/${order.id}/edit`)
  const goToPrint = () => router.visit(`/organizations/${organizationSlug}/orders/${order.id}/print`)
  const goToActivity = () => router.visit(`/organizations/${organizationSlug}/orders/${order.id}/activity`)

  return (
    <Group justify="space-between" align="center">
      <div>
        <Title>Commande #{order.id}</Title>
        <Text size="sm" c="dimmed">
          Créée le {dayjs(order.created_at).format('DD/MM/YYYY HH:mm')}
          {order.creator ? ` par ${order.creator.name}` : ''}
        </Text>
      </div>
      <Menu position="bottom-end">
        <Menu.Target>
          <ActionIcon variant="subtle" color="gray" size="lg">
            <IconDotsVertical size={20} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          {canEdit && (
            <Menu.Item leftSection={<IconEdit size={14} />} onClick={goToEdit}>
              Modifier
            </Menu.Item>
          )}
          <Menu.Item leftSection={<IconPrinter size={14} />} onClick={goToPrint}>
            Imprimer
          </Menu.Item>
          <Menu.Item leftSection={<IconHistory size={14} />} onClick={goToActivity}>
            Activité
          </Menu.Item>
          {canDelete && (
            <>
              <Menu.Divider />
              <Menu.Item color="red" leftSection={<IconTrash size={14} />} onClick={onDelete}>
                Supprimer
              </Menu.Item>
            </>
          )}
        </Menu.Dropdown>
      </Menu>
    </Group>
  )
}
